export class Federation {
  static all() {
    return [
      {
        id: 1,
        abbr: 'CBJJ',
        name: 'Confederação Brasileira de Jiu-Jitsu',
        email: 'cbjj@cbjj.com.br'
      },
      {
        id: 2,
        abbr: 'USBJJF',
        name: 'United States Brazilian Jiu-Jitsu Federation',
        email: 'ibjjf@ibjjf.com'
      },
      {
        id: 3,
        abbr: 'IBJJF',
        name: 'International Brazilian Jiu-Jitsu Federation',
        email: 'ibjjf@ibjjf.com'
      },
      {
        id: 4,
        abbr: 'JBJJF',
        name: 'Japan Brazilian Jiu-Jitsu Federation',
        email: 'ibjjf@ibjjf.com'
      },
      {
        id: 5,
        abbr: 'FPJJB',
        name: 'Federação Portuguesa de Jiu-Jitsu Brasileiro',
        email: 'ibjjf@ibjjf.com'
      }
    ]
  }

  static findById(federationId) {
    return this.all().find(fed => fed.id === +federationId)
  }

  static findByAbbr(federationAbbr) {
    return this.all().find(fed => fed.abbr === federationAbbr)
  }
}
